module.exports = __webpack_public_path__ + "img/COMBO RAINBOW BW.ff40a63.svg";